/**
 * 패널 SQL 에 노드(RAC) 조건 넣기(2026-10-18) — 패널 편집에서 「노드」 를 고를 때 쓴다.
 *
 * 수집 저장소(mon_metrics)는 노드마다 한 줄이고(labels.inst_id) 서버가 패널 정의의 노드를 `:inst_no` 로 채운다(0 = 합계).
 * 그런데 그 조건은 **SQL 에 적혀 있어야** 걸린다 — 예전에 만든 패널 SQL 에는 없어서 노드를 골라도 아무 일이 없었다(신고).
 * 그래서 노드를 고르면 조건을 SQL 에 직접 넣어 **바뀐 것이 보이게** 한다. 같은 시각의 값을 MAX 로 고르던 피벗은 합계가 되도록 SUM 으로
 * 바꾼다(MAX 면 합계가 「가장 큰 노드」 가 된다) — 비율(적중률 등)은 더할 수 없으므로 두고 그 사실을 알린다.
 *
 * 수집 저장소를 읽지 않는 SQL(대상 DB 에 직접 묻는 패널)은 손대지 않는다 — 어디에 노드 조건을 둘지 SQL 을 봐야만 안다.
 */

export const NODE_COND = "(:inst_no = 0 OR json_extract(labels, '$.inst_id') = :inst_no)";
const RATIO_RE = /hit|ratio|pct|percent|rate/i;

/** SQL 의 노드 상태 — 'bound'(이미 :inst_no 를 쓴다) | 'store'(수집 저장소를 읽는데 조건이 없다) | 'other'(수집 저장소가 아니다) */
export function nodeSqlState(sql) {
    const s = String(sql || '');
    if (/:inst_no\b/.test(s)) return 'bound';
    return /\bmon_metrics\b/i.test(s) ? 'store' : 'other';
}

/**
 * 노드 조건을 넣고 MAX 피벗을 SUM 으로. 바꿀 수 없으면 null.
 * @returns {{ sql: string, addedCond: boolean, maxToSum: number, keptRatio: string[] } | null}
 */
export function addNodeFilter(sql) {
    const src = String(sql || '');
    if (nodeSqlState(src) !== 'store') return null;
    // 조건 자리 — WHERE 가 있으면 그 조건들 끝(GROUP BY · ORDER BY · LIMIT 앞, 없으면 끝), 없으면 FROM mon_metrics 바로 뒤에 WHERE 로
    const tailRe = /\n?[ \t]*\b(GROUP\s+BY|ORDER\s+BY|LIMIT)\b/i;
    let out;
    if (/\bWHERE\b/i.test(src)) {
        const whereAt = src.search(/\bWHERE\b/i);
        const rest = src.slice(whereAt);
        const m = rest.match(tailRe);
        const cut = m ? whereAt + m.index : src.length;
        out = `${src.slice(0, cut).replace(/\s+$/, '')}\n  AND ${NODE_COND}\n${src.slice(cut).replace(/^\n/, '')}`;
    } else {
        out = src.replace(/(\bFROM\s+mon_metrics\b)/i, `$1\nWHERE ${NODE_COND}`);
    }
    let maxToSum = 0;
    const keptRatio = [];
    out = out.replace(/MAX\(\s*CASE\s+WHEN\s+(metric_name|json_extract\(\s*labels\s*,\s*'\$\.name'\s*\))\s*=\s*'([^']+)'/gi, (whole, col, name) => {
        if (RATIO_RE.test(name)) { keptRatio.push(name); return whole; }
        maxToSum += 1;
        return whole.replace(/^MAX/i, 'SUM');
    });
    return { sql: out.replace(/\s+$/, ''), addedCond: true, maxToSum, keptRatio };
}
